import { FC, useEffect } from 'react'
import { OnboardingPagePreset } from 'components/features/creditCard/creditCardOnboarding/OnboardingPagePreset/OnboardingPagePreset'
import styles from 'components/features/creditCard/creditCardOnboarding/SubmittingStepPage/SubmittingStepPage.styl'
import { sleep } from 'helpers/utilsHelpers'
import ProgressBar from 'components/atoms/ProgressBar/ProgressBar'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { GetCCOnboardingStateAction } from 'components/features/creditCard/creditCardStore/actions'
import { INDICATOR_CHECK_STEP } from 'components/features/pfm/StepIndicator/StepIndicator'

const PENDING_STEP_PAGE_DELAY = 10000

export const SubmittingStepPage: FC<{}> = () => {

  const dispatch = useStoreDispatch()
  useEffect(() => {
    async function toggleIsLoaded () {
      await sleep(PENDING_STEP_PAGE_DELAY)
      dispatch(new GetCCOnboardingStateAction())
    }
    toggleIsLoaded()
  })

  const cardChild = (
    <div className={ styles.spinnerWrapper } data-qa-marker='submitting-card'>
      <div className={ styles.title }>
        Preparing your card...
      </div>
      <ProgressBar progressPercent={ 100 } autoLoadTime={ PENDING_STEP_PAGE_DELAY + 2000 } />
    </div>
  )

  return (
    <OnboardingPagePreset
      step={ INDICATOR_CHECK_STEP }
      title='You’re almost done'
      card={ cardChild }
      progressPercent={ 80 }
    />
  )
}
